import React from 'react';

const IconClose16 = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
      <g fill="none" fillRule="evenodd">
        <g fill="#5A5A5A">
          <g>
            <g>
              <path
                d="M9.208 8.125l4.817-4.818c.3-.3.3-.783 0-1.082-.299-.3-.783-.3-1.082 0L8.125 7.042 3.307 2.225c-.3-.3-.783-.3-1.082 0-.3.299-.3.783 0 1.082l4.817 4.818-4.817 4.818c-.3.3-.3.783 0 1.082.149.15.345.225.54.225.197 0 .393-.075.542-.225l4.818-4.817 4.818 4.817c.15.15.345.225.541.225.196 0 .392-.075.541-.225.3-.299.3-.783 0-1.082L9.208 8.125z"
                transform="translate(-136 -104) translate(104 72) translate(32 32)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default IconClose16;
